enum PaymentReceivedFromType {
  USER = "USER",
  CONTACT = "CONTACT",
  EXTERNAL = "EXTERNAL",
}

export default PaymentReceivedFromType;
